// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"245c3d62","463":"304a6fdc","523":"3a947e2e"}[chunkId] + ".chunk.js";
};